var SJ = SJ || {};
var __ = __ || function(str) { return str; };

SJ.Responsive = SJ.Responsive || {

    init: function() {
        /*
         *  Get things started
         */

        if (/Android|AppleWebKit|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            var wi = window.screen.width;
            if (wi > 767) {
                this.addViewportTagTablet();
            } else {
                this.addViewportTagMobile();
            }
        }

        this.addTableOverflowDiv();
    },

    /*
     *  Add Viewport meta tag
     */
    addViewportTagTablet: function() {

        // Set viewport tag
        var viewPortTag = document.createElement('meta');
        viewPortTag.id = "viewport";
        viewPortTag.name = "viewport";
        viewPortTag.content = "initial-scale = 1.0, maximum-scale = 1.0, user-scalable = no, width = device-width";
        document.getElementsByTagName('head')[0].appendChild(viewPortTag);
    },

    addViewportTagMobile: function() {

        // Set viewport tag
        var viewPortTag = document.createElement('meta');
        viewPortTag.id = "viewport";
        viewPortTag.name = "viewport";
        viewPortTag.content = "user-scalable = no, width = 768";
        document.getElementsByTagName('head')[0].appendChild(viewPortTag);
    },

    /*
     *  DIV table overflow
     */
    addTableOverflowDiv: function() {

        $(".bs3-table").wrap("<div class='sj-overflow'></div>");
    }
};


/*
 *  This is to wrap tables so they don't overflow and
 */
$(document).ready(function() {

SJ.Responsive.init();

});
